<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo_white.png" alt="logo图"> -->
    </div>
    <p class="title">合肥爱达健康科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：安徽省合肥市经济技术开发区蓬莱路</span>
    </p>
    <p class="email_wx">
      <span>Tel：18705643434</span>
    </p>
    <p class="copy">
      <span>
        Copyright &copy; 2023 - {{ new Date().getFullYear() }} 爱达健康
      </span>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">皖ICP备2023025287号-1</a>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=34019102001409" rel="noreferrer" target="_blank">
        <img src="@/assets/img/icon_filing.png" alt="" />
        皖公网安备34019102001409号
      </a>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.copy a {
  color: #d3d3d3;
  display: flex;
  align-items: center;
}
.copy img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue